import { resolveWithBody } from "./Utils/utils";

export default {
    init(promiseRequest) {
        return {
            getCompetitorManagementStats(eventId) {
                return promiseRequest({
                    url: `/api/admin/events/${eventId}/competitor-stats`,
                    method: "get",
                    json: true,
                }).then(resolveWithBody());
            },
        };
    },
};
